import { Component, HostListener, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-grid',
  standalone: false,
  templateUrl: './grid.component.html',
  styleUrl: './grid.component.scss'
})
export class GridComponent {
  @Input() items: any[] = [];
  @Input() rows: number = 2; // Default rows
  @Input() cardTemplate!: TemplateRef<any>;
  @Input() newTemplate: TemplateRef<any> | null = null;
constructor(){
  let a = 10;
}
  getProcessedItems(): any[] {
    if (!this.items) return [];
    const processedItems = this.newTemplate ? [this.newTemplate, ...this.items] : [...this.items];
    
    const rowCount = this.rows;
    const columnCount = Math.ceil(processedItems.length / rowCount);
    
    // Reordering to fill rows first
    const orderedItems: any[] = new Array(processedItems.length);
    let index = 0;
    for (let row = 0; row < rowCount; row++) {
      for (let col = 0; col < columnCount; col++) {
        const itemIndex = row * columnCount + col;
        if (itemIndex < processedItems.length) {
          orderedItems[index++] = processedItems[itemIndex];
        }
      }
    }
    return orderedItems;
  }
  trackByFn(index: number, item: any): any {
    if(item.BookId) return item.BookId;
    if(item.ChapterId) return item.ChapterId;
    return 'new-template';
  }
}
